import { render } from "./SimpleNotification.vue?vue&type=template&id=41888c3a&scoped=true"
import script from "./SimpleNotification.vue?vue&type=script&lang=js"
export * from "./SimpleNotification.vue?vue&type=script&lang=js"

import "./SimpleNotification.vue?vue&type=style&index=0&id=41888c3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41888c3a"]])

export default __exports__